import { activitiesService } from '../features/activities/api/activitiesApi';

export const ACTIVITY_TYPES = {
  TASK_CREATED: 'TASK_CREATED',
  TASK_UPDATED: 'TASK_UPDATED',
  TASK_COMPLETED: 'TASK_COMPLETED',
  TASK_DELETED: 'TASK_DELETED',
  PROJECT_CREATED: 'PROJECT_CREATED',
  PROJECT_UPDATED: 'PROJECT_UPDATED',
  PROJECT_DELETED: 'PROJECT_DELETED',
  MEMBER_ADDED: 'MEMBER_ADDED',
  MEMBER_REMOVED: 'MEMBER_REMOVED',
  RESOURCE_BOOKED: 'RESOURCE_BOOKED',
  RESOURCE_RETURNED: 'RESOURCE_RETURNED',
  USER_LOGIN: 'USER_LOGIN',
  USER_LOGOUT: 'USER_LOGOUT',
};

export const activityLogService = {
  // Server logs activities automatically — no client-side write endpoint available.
  async logActivity(_userId, _type, _details, _projectId = null) {
    return { success: true };
  },

  async getRecentActivities(limit = 50) {
    try { return await activitiesService.getRecentActivities(limit); }
    catch { return []; }
  },

  async getUserActivities(userId, limit = 50) {
    try {
      return userId
        ? await activitiesService.getUserActivities(userId, limit)
        : await activitiesService.getMyActivities(limit);
    } catch { return []; }
  },

  async getProjectActivities(projectId, limit = 100) {
    try { return await activitiesService.getProjectActivities(projectId, limit); }
    catch { return []; }
  },
};
